
export enum ACCION_FORM { 
    LISTADO="listado",
    CONSULTAR="consultar",
    AGREGAR="agregar",
    MODIFICAR="modificar",
    BORRADO_FISICO      = "borradoFisico",
    BORRADO_LOGICO      = "borradoLogico",
}